<template>
  <div v-if="showPopup" class="is-popup">
    <div class="swiper-box">
      <div class="content-box">
        <!-- 轮播 -->
        <template v-if="content.type != 1">
          <van-swipe
            class="is-popup-add-box"
            :show-indicators="false"
            :autoplay="content.autoPlay ? 0 : 5000"
            :style="{height: imgHeight + 'px'}"
            style="max-height: 92%;"
            @change="onChange"
          >
            <van-swipe-item
              v-for="(item, index) in content.data"
              :key="index"
              @click="goNext(item)"
            >
              <div style="position: relative;" :style="{height: imgHeight + 'px'}">
                <img :src="item.url" :style="{borderRadius: facade.picture_radius + 'px'}" style="width: 100%;height: 100%;" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </template>

        <!-- 叠放 -->
        <div v-else class="is-popup-add-box" :style="{height: imgHeight + 'px'}" style="max-height: 92%;">
          <div v-for="(item, index) in content.data" :key="index">
            <div v-if="curIndex == index" style="position: relative;" :style="{height: imgHeight + 'px'}" @click="goNext(item)">
              <img :src="item.url" :style="{borderRadius: facade.picture_radius + 'px'}" style="width: 100%;height: 100%;" />
            </div>
          </div>
        </div>

        <!-- 指示器 -->
        <div style="width: 100%;" v-if="facade.indicator_style !== 4">
          <pointer
            :margin="46"
            :data="content.data"
            :index="curIndex"
            :bottom="bottom"
            :color="facade.indicator_color"
            :type="facade.indicator_style"
            :align="facade.indicator_align"
          />
        </div>
        <van-icon name="close" :size="26" color="#FFF" class="is-close-mask-icon" @click="handlerClose" />
      </div>
    </div>
  </div>
</template>

<script>
import pointer from './pointer.vue';

export default {
  components: {
    pointer
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    },
  },
  data() {
    return {
      showPopup: true,
      windowHeight: 0,
      curIndex: 0,
    }
  },
  computed: {
    imgHeight() {
      let screenWidth = window.innerWidth
      let curWidth = screenWidth - 42
      let nub = 0
      if (this.content.imgSize == 1) {
        nub = curWidth * 640 / 580
      } else if (this.content.imgSize == 2) {
        nub = curWidth * 750 / 580
      } else {
        nub = curWidth * 840 / 580 // 580 * 840
      }
      console.log({
        imgHeight: nub,
        bottom: this.bottom,
        windowHeight: this.windowHeight
      })
      return nub;
    },
    bottom() {
      let screenWidth = window.innerWidth
      let curWidth = screenWidth - 42
      let nub = 0
      let num = 0
      if (this.content.imgSize == 1) {
        nub = curWidth * 640 / 580
      } else if (this.content.imgSize == 2) {
        nub = curWidth * 750 / 580
      } else {
        nub = curWidth * 840 / 580 // 580 * 840
      }
      num = (this.windowHeight - nub) / 2 + 28
      return num
    }
  },
  watch: {},
  mounted() {
    this.windowHeight = window.innerHeight;
    console.log('this.windowHeight', this.windowHeight)
    this.showPopup = true
  },
  methods: {
    onChange(e) {
      this.curIndex = e
    },
    goNext(item) {
      this.$emit('go-next', item.link)
    },
    handlerClose() {
      if (this.content.type == 1 && this.curIndex < this.content.data.length - 1) {
        this.curIndex++
      } else {
        this.showPopup = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.is-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  z-index: 100000;

  .swiper-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .is-popup-add-box {
      width: calc(100% - 84px);
    }

    .is-close-mask-icon {
      font-size: 26px;
      color: white;
      margin-top: 10px;
      display: inline-block;
    }
  }
}
</style>